import authModule from "../../../../../utilities/AuthModule";
import { axiosRetryGet, axiosRetryPost } from "../../../../../utilities/AxiosRetryUtil";
import { logger } from "../../../../../utilities/logger";
import { IApproval, IApprovalResponse, IReassignResponse } from "./ApprovalsModels";

export class ApprovalsService {
    private tenantId: string;
    constructor(tenantId: string) {
        this.tenantId = tenantId;
    }

    public async getMyApprovals(): Promise<IApproval[]> {
        // return (
        //     await this.getData(
        //         "/approvalViews?$top=100&$filter=properties/userRole+eq+'Approver'+and+properties/isActive+eq+'true'+and+properties/isDescending+eq+'false'&api-version=2016-11-01"
        //     )
        // );
        try {
            let approvalResponse: any = await this.getData(
                "/approvalViews?$filter=properties/userRole+eq+'Approver'+and+properties/isActive+eq+'true'+and+properties/isDescending+eq+'false'&api-version=2016-11-01"
            );
    
            let approvals: IApproval[] = approvalResponse?.value;
            if (approvals?.length > 0) {
                let nextLink: string = approvalResponse?.nextLink;
                while (nextLink) {
                    approvalResponse = await this.getData(nextLink, true);
                    approvals = approvals.concat(approvalResponse?.value ?? []);
                    nextLink = approvalResponse?.nextLink;
                }
            }
            return approvals ?? [];   
        } catch (error) {
            logger(error, "ApprovalsService.ts (getMyApprovals)");
        }
        return [];
    }

    public async respond(approvalName: string, comment: string, response: string): Promise<IApprovalResponse> {
        try {
            return this.postData(`/approvals/${approvalName}/approvalResponses?api-version=2016-11-01`, {
                properties: { response: response, comments: comment },
            });   
        } catch (error) {
            logger(error, "ApprovalsService.ts (respond)");
        }
        return null;
    }

    public async reassign(approvalName: string, assignedToEmail: string, userUniqueId: string): Promise<IReassignResponse> {

        const accessToken = await authModule.getFlowAccessToken();
        const responses: IReassignResponse[] = (await axiosRetryGet(`${this.getBaseUrl()}/approvals/${approvalName}/approvalRequests?api-version=2016-11-01`, {
            headers: {
                authorization: `Bearer ${accessToken}`,
                accept: "application/json",
            },
        }))?.data;
        if (responses) {
            //now find the NAME attribute of the object where properties.assignTo.id === currentUser.id
            const userName = responses.find(response => response.properties.assignedTo.id === userUniqueId)?.name;
            try {
                const response = await this.postData(`/approvals/${approvalName}/approvalRequests/${userName}/reassign?api-version=2016-11-01`, { assignedTo: assignedToEmail });
                return response;   
            } catch (error) {
                logger(error, "ApprovalsService.ts (reassign - postData)");
            }
        }
        return null;
    }

    protected getBaseUrl(): string {
        return `https://emea.api.flow.microsoft.com/providers/Microsoft.ProcessSimple/environments/Default-${this.tenantId}`;
    }

    protected getData = async (url: string, isNextPageRequest: boolean = false) => {
        try {
            const accessToken = await authModule.getFlowAccessToken();
            const response = await axiosRetryGet(
                !isNextPageRequest ? `${this.getBaseUrl()}${url}` : url,
                {
                    headers: {
                        authorization: `Bearer ${accessToken}`,
                        accept: "application/json",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.statusText);
            }
        } catch (err) {
            throw err;
        }
    }

    protected postData = async (url: string, body: any) => {
        try {
            const accessToken = await authModule.getFlowAccessToken();
            const response = await axiosRetryPost(
                `${this.getBaseUrl()}${url}`,
                body,
                {
                    headers: {
                        authorization: `Bearer ${accessToken}`,
                        accept: "application/json",
                        "content-type": "application/json;charset=UTF-8",
                    },
                }
            );

            if (response && response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.statusText);
            }
        } catch (err) {
            throw err;
        }
    }
}